import { render, staticRenderFns } from "./ForwardRulesView.vue?vue&type=template&id=f3c20a9e&"
import script from "./ForwardRulesView.vue?vue&type=script&lang=js&"
export * from "./ForwardRulesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports